<style lang="scss" src="./SolicitudesPendientesTabla.scss"></style>
<template src="./SolicitudesPendientesTabla.html"></template>

<script>
import {Alert, Divider, Pagination, Table, TableColumn, Tag, Tooltip} from 'element-ui';
import {requestAfiliacionMixin} from "@/api/ciudadano/afiliacionApi";
import {requestRevisionMixin} from "@/api/partidoPolitico/revisionApi";
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import {NotifyMixin} from "@/mixins/NotifyMixin";
import moment from "moment";
import {TableMixin} from "@/mixins/TableMixin";
import {utils} from "@/utils";
import ToolbarSearch from "@/components/Shared/ToolbarSearch/ToolbarSearch";
import {ActividadCiudadanoEstadoMixin} from "@/mixins/actividadCiudadanoEstado";

export default {
  name: "SolicitudesPendientesTabla",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Tooltip.name]: Tooltip,
    [Pagination.name]: Pagination,
    [Divider.name]: Divider,
    [Tag.name]: Tag,
    [Alert.name]: Alert,
    ToolbarSearch,
  },
  mixins: [
    requestAfiliacionMixin,
    requestRevisionMixin,
    ScreenSizeMixin,
    NotifyMixin,
    TableMixin,
    ActividadCiudadanoEstadoMixin
  ],
  data() {
    return {
      pickerOptFilterDate: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      listSelection: [],
      isSelect: false,
    }
  },
  beforeMount() {
    const pagingQuery = {
      currentPage: this.pagination.currentPage,
      pageSize: this.pagination.pageSize,
    }
    this.getList(pagingQuery, true)
  },
  methods: {
    getList(pagingQuery = {}, firstTime = false) {
      this.loading = true
      pagingQuery['compress'] = false
      pagingQuery['fields'] = ['id', 'run', 'nombres', 'paterno', 'materno', 'fechanacimiento', 'region', 'comuna', 'domicilio', 'fechacompleta', 'tipo_afiliacion', 'estado', 'codigoestado']

      this.getListaAfiliacionRevision(pagingQuery)
        .then(response => {
          this.$log.debug('getListaAfiliacionRevision', response.data.statusCode)

          if (response.data.statusCode === 200) {
            this.pagination.total = response.data.totalItems

            const data = JSON.parse(response.data.datos)
            this.tableData = data.map(row => {
              row.fechacompleta = moment.utc(row.fechacompleta).local().format('DD-MM-YYYY HH:mm')
              row.run = utils.rutFilter(row.run)
              return row
            })

            this.$log.debug(this.tableData)

            this.errored = false
            if (this.tableData.length === 0) {
              if (firstTime) {
                this.showError('No hay solicitudes pendientes para su partido político, puede presionar el botón refrescar si lo desea.')
              } else {
                this.showWarn('No hay solicitudes pendientes con sus filtros, puede presionar el botón refrescar si lo desea.')
              }
            }
            this.$scrollTo('#tablePendiente')
          } else {
            this.errored = true
            this.showError('Ocurrió un error inesperado al cargar los datos')
          }
        })
        .catch(err => {
          this.$log.fatal('getListaAfiliacionRevision', err, err.response, err.request)
          this.errored = true
          this.showError('Ocurrió un error inesperado al cargar los datos')
        })
        .finally(() => {
          this.loading = false
        })
    },
    verSolicitud(id, estado) {
      this.$log.debug('onVerSolicitud', id, estado)
      this.$emit('on-ver-solicitud', id, estado)
    },
    checkSelection() {
      this.$log.debug('onCheckSelection', this.listSelection)
      this.$emit('on-check-selection', this.listSelection)
    },
    checkAll() {
      this.$log.debug('onCheckall')
      this.$emit('on-check-all', this.querySearch, this.dateFilter)
    },
  },
  computed: {
    perPage() {
      if (this.parametro.params)
        return parseInt(this.parametro.params.solicitudpendientepaginacion)
      return 10
    },
  },
}
</script>
